module.exports = __webpack_public_path__ + "img/video-lab.c087fb1d.jpg";